// extracted by mini-css-extract-plugin
export var audioPlayer = "_p7-0";